import SmartLockApiCallerInstance from '../utils/SmartLockApiCallerInstance';
import { SMART_LOCK_API_ENDPOINTS } from '../URLConstants';

export const GetAllVehicles = async (page, search, filterBy) => {
  const response = await SmartLockApiCallerInstance.get(
    `${SMART_LOCK_API_ENDPOINTS.VEHICLE_URL}?page=${page}&limit=10&search=${search}&filterBy=${filterBy}`
  );
  return response;
};

export const CreateNewVehicle = async (data) => {
  const response = await SmartLockApiCallerInstance.post(
    SMART_LOCK_API_ENDPOINTS.VEHICLE_URL,
    data
  );
  return response;
};
export const GetVehicleDetailsById = async (id) => {
  const response = await SmartLockApiCallerInstance.get(
    `${SMART_LOCK_API_ENDPOINTS.VEHICLE_URL}/${id}`
  );
  return response;
};
export const UpdateVehicleDetailsById = async (data, id) => {
  const response = await SmartLockApiCallerInstance.patch(
    `${SMART_LOCK_API_ENDPOINTS.VEHICLE_URL}/${id}`,
    data
  );
  return response;
};
export const DeleteVehicleByID = async (id) => {
  const response = await SmartLockApiCallerInstance.delete(
    `${SMART_LOCK_API_ENDPOINTS.VEHICLE_URL}/${id}`
  );
  return response;
};
export const GetVehicleList = async () => {
  const response = await SmartLockApiCallerInstance.get(
    `${SMART_LOCK_API_ENDPOINTS.ALL_VEHICLE_DATA}`
  );
  return response;
};
